[
  {
    "data_types": ["name", "email address", "mobile number", "general location", "password"],
    "category": "Registration Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [38, 39, 40, 41],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "education",
      "work experience",
      "skills",
      "photo",
      "city or area",
      "endorsements",
      "verifications of information"
    ],
    "category": "Profile Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [45, 46, 47],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [259, 260, 261, 262, 263],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["demographic data", "salary", "resume", "job application"],
    "category": "User-Provided Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [51, 52, 53],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [317, 318, 319, 320, 321, 322],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["calendar meeting information"],
    "category": "Calendar Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [54, 55, 56],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["content", "posts", "comments", "audio"],
    "category": "User-Generated Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [59, 60],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [259, 260, 261, 262, 263],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["public information", "professional-related news", "accomplishments"],
    "category": "Public Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [60],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [259, 260, 261, 262, 263],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["contact information", "email header information"],
    "category": "Contact and Calendar Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [61, 62, 63],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["job title", "work email address"],
    "category": "Partner-Provided Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [64, 65, 66, 67],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [317, 318, 319, 320, 321, 322],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["usage data", "log-ins", "cookies", "device information", "IP addresses"],
    "category": "Service Use Information",
    "purposes": [
      {
        "reason": "Improve and personalize services",
        "evidence": [71, 72, 73, 74, 75],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["device IDs", "ad ID", "IP address", "operating system", "browser information"],
    "category": "Cookies and Similar Technologies",
    "purposes": [
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [77, 78, 79, 80, 81, 82, 83, 84, 85, 86],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Advertisers",
        "evidence": [193, 194, 195, 196, 197, 198, 199, 200, 201, 202],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "URL of the site you came from",
      "URL of the site you go to",
      "time of your visit",
      "network information",
      "device information",
      "location data"
    ],
    "category": "Device and Location Information",
    "purposes": [
      {
        "reason": "Improve and personalize services",
        "evidence": [91, 92, 93, 94, 95, 96],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["messages", "events", "connection requests", "marketing communications"],
    "category": "Communication Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [98, 99, 100, 101, 102, 103, 104],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["employer-provided data", "school-provided data"],
    "category": "Workplace and School Provided Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [108, 109, 110],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Partners and Affiliates",
        "evidence": [317, 318, 319, 320, 321, 322],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "data from sites with LinkedIn ads",
      "data from sites with LinkedIn plugins",
      "data from sites where you log-in with LinkedIn"
    ],
    "category": "Sites and Services of Others",
    "purposes": [
      {
        "reason": "Improve and personalize services",
        "evidence": [112, 113],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [324, 325, 326, 327, 328, 329, 330],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": ["payment information", "billing information"],
    "category": "Payment Information",
    "purposes": [
      {
        "reason": "Process transactions or payments",
        "evidence": [42, 43, 44],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "As long as necessary to provide services",
        "evidence": [346, 347],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [331, 332, 333],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  }
]
